import { APP_ENV, GIT_HASH } from '@paperstac/env';
import { matchPath } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { Replay } from '@sentry/replay';
import { Integrations } from '@sentry/tracing';
import { createBrowserHistory } from 'history';
import * as webRoutes from '@paperstac/routes/lib/webRoutes';

const history = createBrowserHistory();
const routes = Object.values(webRoutes).map((path) => ({ path }));

Sentry.init({
  dsn: 'https://eb8dfbca4baa4fc5b82449b923c52195@sentry.io/258282',
  environment: APP_ENV,
  release: GIT_HASH,
  replaysSessionSampleRate: 0, // 0% of user sessions
  replaysOnErrorSampleRate: 1.0, // 100% of error sessions
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(history, routes, matchPath),
    }),
    new Replay({
      maskAllText: false,
      blockAllMedia: false,
      maskAllInputs: false,
    }),
  ],
  maxBreadcrumbs: 20,
  tracesSampleRate: 0.01, // 1% of transactions sampled for Performance Monitoring
});

export default Sentry;

export { history };
